import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-down', 'IconClockDown', [
  ['path', { d: 'M20.984 12.535a9 9 0 1 0 -8.431 8.448', key: 'svg-0' }],
  ['path', { d: 'M12 7v5l3 3', key: 'svg-1' }],
  ['path', { d: 'M19 16v6', key: 'svg-2' }],
  ['path', { d: 'M22 19l-3 3l-3 -3', key: 'svg-3' }],
]);
